import type { TileConcreteDisplayProps } from '../../../types/rendering.js';
import { CanvasSquareRenderer } from '../renderers/CanvasSquareRenderer.js';

export const CanvasSquareDisplay = (props: TileConcreteDisplayProps) => {
  const {
    center: { x, y },
    fillColor,
    width,
    radius,
    value,
    name,
    truncationMode,
    labelsDisplay,
  } = props;
  const halfWidth = width / 2;

  return (
    <CanvasSquareRenderer
      x={x - halfWidth}
      y={y - halfWidth}
      width={width}
      fillColor={fillColor}
      radius={radius}
      name={name}
      value={value}
      strokeColor="transparent"
      truncationMode={truncationMode}
      labelsDisplay={labelsDisplay}
    />
  );
};

CanvasSquareDisplay['displayName'] = 'CanvasSquareDisplay';
